import styled from "styled-components";
import { Modal } from "react-bootstrap";

export const ModalStyle = styled(Modal)`
  .modal-content {
    padding: 25px 60px;
    border-radius: 10px;
    max-width: 500px;
    width: 100%;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  span {
    color: ${({ theme }) => theme.colors.purple};
    font-size: 1.125rem;
    font-family: "Mangueira bold";
  }
  svg {
    cursor: pointer;
    color: #074f8c;
  }
`;

export const Title = styled.p`
  margin: 0;
  color: ${(props) => props.theme.colors.gray};
  font-size: 0.875rem;
`;

export const ContainerButtons = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;

  button {
    width: 100%;
  }
  button:first-child {
    margin-right: 20px;
  }
`;

export const Messenger = styled.span`
  font-size: 0.8125rem;
  color: #8f8f8f;
`;
